class Logger {
  debug (message) {
    console.log(message)
  }
}
export default new Logger()



// WEBPACK FOOTER //
// ./src/helpers/logger.js